// CalendarMonth > Day > IDay
export const calendarMonthDayDefaultProps = Object.freeze({
	isSelected: false
})

export type CalendarMonthDayProps = {
	date: Date
	displayDate: Date
	onSelect(date: Date): void
} & typeof calendarMonthDayDefaultProps
